"use strict";

var _classCallCheck = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var error_1 = require("./error");

var TRANSACTION_NOT_FOUND = 10;

var ArangoTransaction = /*#__PURE__*/function () {
  function ArangoTransaction(connection, id) {
    _classCallCheck(this, ArangoTransaction);

    this.isArangoTransaction = true;
    this._connection = connection;
    this.id = id;
  }

  _createClass(ArangoTransaction, [{
    key: "exists",
    value: function exists() {
      return this.get().then(function () {
        return true;
      }, function (err) {
        if (error_1.isArangoError(err) && err.errorNum === TRANSACTION_NOT_FOUND) {
          return false;
        }

        throw err;
      });
    }
  }, {
    key: "get",
    value: function get() {
      return this._connection.request({
        path: "/_api/transaction/".concat(this.id)
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "commit",
    value: function commit() {
      return this._connection.request({
        method: "PUT",
        path: "/_api/transaction/".concat(this.id)
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "abort",
    value: function abort() {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/transaction/".concat(this.id)
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "run",
    value: function run(fn) {
      this._connection.setTransactionId(this.id);

      try {
        return Promise.resolve(fn());
      } finally {
        this._connection.clearTransactionId();
      }
    }
  }]);

  return ArangoTransaction;
}();

exports.ArangoTransaction = ArangoTransaction;